import { chakra, type StyleProps } from '@chakra-ui/react'
import type { RenderLeafProps } from 'slate-react'

export default function RichTextLeaf({
  attributes,
  children,
  leaf,
  styleProps = {},
}: RenderLeafProps & { styleProps?: StyleProps }): React.ReactElement {
  const props: StyleProps = { ...styleProps }

  const { bold, underline, italic, color } = leaf
  if (bold != null) {
    props.fontWeight = bold ? 'bold' : 'normal'
  }
  if (underline != null) {
    props.textDecoration = underline ? 'underline' : 'none'
  }
  if (italic != null) {
    props.fontStyle = italic ? 'italic' : 'normal'
  }
  if (color != null) {
    // TODO: Refactor dynamic color from `leaf.color` to semantic token if possible.
    // The value of `leaf.color` is determined at runtime, so direct mapping is not feasible here.
    props.color = color
  }

  return (
    <chakra.span {...attributes} {...props}>
      {children}
    </chakra.span>
  )
}
